import { ResourceRecorder } from '../src/ResourceRecorder.ts';

export const globalMacrosCSSRecorder = new ResourceRecorder();
export const globalMacrosJSRecorder = new ResourceRecorder();
